<template>
  <BaseModal
    small
    :heading="$t('admin.general_settings.delete_account_title')"
    useForm
    @submit="handleAccountDelete"
    @close="$emit('close')"
  >
    <Flex direction="column">
      <div
        v-for="(error, index) in formErrors"
        :key="`form-error-${index}`"
      >
        <BaseAlert
          color="error"
          :text="$t('global.validations.invalid', { value: error.attribute })"
        />
      </div>

      <Flex
        direction="column"
        :gap="2"
      >
        <BaseAlert
          color="error"
          :text="$t('admin.general_settings.delete_description')"
        />

        <BaseCheckbox
          v-model="formData.deleteConfirmation"
          :label="$t('admin.general_settings.delete_confirm')"
          :description="$t('admin.general_settings.delete_confirm_hint')"
          required
          v-test="'delete-account-confirm-checkbox'"
        />

        <BaseText bold>{{ $t('global.password_confirmation') }}</BaseText>
      </Flex>
      <BaseInput
        v-model="formData.password"
        type="password"
        :label="$t('global.password')"
        required
        v-test="'delete-account-password-input'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        submitForm
        v-test="'delete-account-submit-btn'"
      >
        {{ $t('admin.general_settings.delete_btn') }}
      </BaseButton>

      <BaseButton
        @click="$emit('close')"
        v-test="'ip-modal-save-button'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  lang="ts"
  setup
>
import { reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { flash } from '@/helpers/ui';
import { useCompanyStore } from '@/stores/company';
import type { Error as ErrorType } from '@/types';

const { t } = useI18n();

defineEmits(['close']);

const router = useRouter();
const { deleteCompany } = useCompanyStore();
const formErrors = ref<ErrorType[]>([]);

const formData = reactive({
  deleteConfirmation: false,
  password: '',
});

const handleAccountDelete = () => {
  deleteCompany({
    password: formData.password,
  }).then(({ errors }) => {
    if (errors?.length) {
      formErrors.value = errors;
    } else {
      flash(t('global.flash.account_deleted'));
      setTimeout(() => {
        router.push({ name: 'logged-out' });
      }, 1000);
    }
  });
};
</script>
